/**
 * What somebody with no workspace at all is told.
 *
 * Not "not part of this workspace" — that sentence presumes a workspace, and
 * reads as though they were removed from one. A CenoX account exists before
 * any workspace does; this says so, and offers the two ways to get one.
 */

import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

export const NO_WORKSPACE_MESSAGE =
  'You don’t have a workspace yet. Create a business or join an existing workspace to continue.';

export function NoWorkspaceNotice({
  className,
  showMessage = true,
}: {
  className?: string;
  /** Off where the message is already on screen, so it is not said twice. */
  showMessage?: boolean;
}): ReactNode {
  return (
    <div className={className}>
      {showMessage && <p className="text-sm text-slate-600">{NO_WORKSPACE_MESSAGE}</p>}
      <div className={showMessage ? 'mt-3 flex flex-wrap gap-2' : 'flex flex-wrap gap-2'}>
        <Link
          to="/business/onboarding"
          className="rounded-lg bg-brand-600 px-3 py-1.5 text-sm font-medium text-white hover:bg-brand-700"
        >
          Create Business
        </Link>
        <Link
          to="/business?join=1"
          className="rounded-lg border border-slate-300 px-3 py-1.5 text-sm font-medium text-slate-700 hover:bg-slate-50"
        >
          Join / Accept invite
        </Link>
      </div>
    </div>
  );
}
